import React from "react";
import Navbar from "../components/Navbar";
import HeroEstore from "../components/HeroEstore";
import ProductDetail from "../components/ProductDetail"; 
import ProductsSection from "../components/ProductsSection";
import PaintVisualizer from "../components/PaintVisualizer";
import FAQ from "../components/FAQ";
import Footer from "../components/Footer";
import ScrollToTopButton from "../components/ScrollToTopButton";

export default function ProductDetailPage() {
  return (
    <>
      <Navbar />
      <HeroEstore />
      <ProductDetail />
      <ProductsSection />
      <PaintVisualizer />
      <FAQ />
      <Footer />
      <ScrollToTopButton />
    </>
  );
}
